<template>
  <div id="box">
    <!-- 头部组件 -->
    <header class="box">
      <headers :type="'blue'"></headers>
    </header>
    <div class="home">
      <div class="content flex">
        <div class="left">
          <div class="tab_title">登记公告</div>
          <div
            class="tab_item"
            :class="page == '0' ? 'active' : ''"
            @click="changePage('0')"
          >
            全部 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '1' ? 'active' : ''"
            @click="changePage('1')"
          >
            文字 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '2' ? 'active' : ''"
            @click="changePage('2')"
          >
            口述 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '3' ? 'active' : ''"
            @click="changePage('3')"
          >
            音乐 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '4' ? 'active' : ''"
            @click="changePage('4')"
          >
            戏剧 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '5' ? 'active' : ''"
            @click="changePage('5')"
          >
            曲艺 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '6' ? 'active' : ''"
            @click="changePage('6')"
          >
            舞蹈 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '7' ? 'active' : ''"
            @click="changePage('7')"
          >
            杂技 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '8' ? 'active' : ''"
            @click="changePage('8')"
          >
            美术 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '9' ? 'active' : ''"
            @click="changePage('9')"
          >
            建筑 <i class="icon-youjiantou iconfont"></i>
          </div>



          <div
            class="tab_item"
            :class="page == '10' ? 'active' : ''"
            @click="changePage('10')"
          >
            摄影 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '11' ? 'active' : ''"
            @click="changePage('11')"
          >
            电影 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '12' ? 'active' : ''"
            @click="changePage('12')"
            style="text-indent: 7px;"
          >
            类似摄制电影方法创作的作品 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '13' ? 'active' : ''"
            @click="changePage('13')"
            style="text-indent: 37px;"
          >
            工程设计图,产品设计图 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '14' ? 'active' : ''"
            @click="changePage('14')"
          >
            地图,示意图 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '15' ? 'active' : ''"
            @click="changePage('15')"
          >
            模型 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '16' ? 'active' : ''"
            @click="changePage('16')"
          >
            录音制品 <i class="icon-youjiantou iconfont"></i>
          </div>
          <div
            class="tab_item"
            :class="page == '17' ? 'active' : ''"
            @click="changePage('17')"
          >
            录像制品 <i class="icon-youjiantou iconfont"></i>
          </div>

           <div
            class="tab_item"
            :class="page == '18' ? 'active' : ''"
            @click="changePage('18')"
          >
            其它 <i class="icon-youjiantou iconfont"></i>
          </div>
        </div>
        <div class="right">
          <div class="forms">
            <el-form
              ref="form1"
              class="el-forms"
              :inline="true"
              :model="form"
              label-width="100px"
              size="mini"
            >
              <el-form-item label="作品名称">
                <el-input v-model="form.proName"></el-input>
              </el-form-item>
              <el-form-item label="流水号">
                <el-input v-model="form.waterNum"></el-input>
              </el-form-item>
              <el-form-item label="申请时间">
                <el-date-picker
                  v-model="form.applyTime"
                  type="date"
                  placeholder="申请时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item label="著作权人">
                <el-input v-model="form.copyrightOwner"></el-input>
              </el-form-item>
              <el-form-item label="作者">
                <el-input v-model="form.author"></el-input>
              </el-form-item>
              <el-form-item>
                <div class="bottoms">
                  <el-button type="primary" @click="refreshList()"
                    >查询</el-button
                  >
                  <el-button type="primary" @click="onSubmit()">清空</el-button>
                </div>
              </el-form-item>
            </el-form>
            <div class="table_box">
              <!-- :data="dataList" -->
              <el-table
                :data="dataList"
                border
                size="medium"
                v-loading="loading"
                class="table"
                style="font-size: 16px"
                :header-cell-style="{
                  background: '#DEE8F8',
                  color: '#333333',
                  height: '46px;',
                }"
              >
                <!-- <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column> -->
                <!-- <el-table-column
        prop="productImg"
        show-overflow-tooltip
        sortable="custom"
        label="图片">
        <template slot-scope="scope" v-if="scope.row.productImg">
          <el-image
            style="height: 50px;width:50px;margin-right:10px;"
            :src="imgUrl + src" v-for="(src, index) in scope.row.productImg.split('|')" :key="index">
          </el-image>
        </template>
      </el-table-column> -->
                <el-table-column
                  align="center"
                  prop="registerCode"
                  header-align="center"
                  show-overflow-tooltip
                  label="登记号"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="proName"
                  header-align="center"
                  show-overflow-tooltip
                  label="作品名称"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="proType"
                  :formatter="stateFormat"
                  header-align="center"
                  show-overflow-tooltip
                  label="作品类别"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="registerTime"
                  header-align="center"
                  show-overflow-tooltip
                  label="登记日期"
                >
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="copyrightOwner"
                  header-align="center"
                  show-overflow-tooltip
                  label="著作权人"
                >
                </el-table-column>
              </el-table>
              <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                background
                layout="total, sizes, prev, pager, next, jumper"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部组件 -->
    <div class="box box1">
      <tails></tails>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header";
import tails from "@/components/tail";

export default {
  data() {
    return {
      page: "0",
      form: {
        proName: "",
        waterNum: "",
        applyTime: "",
        copyrightOwner: "",
        author: "",
      },
      userInfo: "",
      pageNo: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      dataList: [],
    };
  },
  components: {
    headers,
    tails,
  },
  created() {},
  mounted() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.refreshList();
  },
  methods: {
    stateFormat(row, column) {
      // // console.log(row, "asdasdasdasdasd");
      // if (row.proType === "1") {
      //   return "文字";
      // } else if (row.proType === "2") {
      //   return "口述";
      // } else if (row.proType === "3") {
      //   return "音乐";
      // } else if (row.proType === "4") {
      //   return "戏剧";
      // } else if (row.proType === "5") {
      //   return "曲艺";
      // } else if (row.proType === "6") {
      //   return "舞蹈";
      // } else if (row.proType === "7") {
      //   return "杂技";
      // } else if (row.proType === "8") {
      //   return "美术";
      // } else if (row.proType === "9") {
      //   return "建筑";
      // }
      if (row.proType === '1') {
          return '文字'
        } else if(row.proType === '2' ) {
          return '口述'
        } else if(row.proType === '3' ) {
          return '音乐'
        } else if(row.proType === '4') {
          return '戏剧'
        }else if(row.proType === '5') {
          return '曲艺'
        }else if(row.proType === '6') {
          return '舞蹈'
        }else if(row.proType === '7') {
          return '杂技'
        }else if(row.proType === '8') {
          return '美术'
        }else if(row.proType === '9') {
          return '建筑'
        }else if(row.proType === '10'){
          return '摄影'
        }else if(row.proType === '11'){
          return '电影'
        }else if(row.proType === '12'){
          return '类似摄制电影方法创作的作品'
        }else if(row.proType === '13'){
          return '工程设计图,产品设计图'
        }else if(row.proType === '14'){
          return '地图,示意图'
        }else if(row.proType === '15'){
          return '模型'
        }else if(row.proType === '16'){
          return '录音制品'
        }else if(row.proType === '17'){
          return '录像制品'
        }else if(row.proType === '18'){
          return '其它'
        }
    },
    refreshList() {
      this.loading = true;
      this.$getHttp("/pc/homePage/getAllCopyright", {
        // userId: this.userInfo.userId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderBy: this.orderBy,
        checkStatus: "4",
        proType: this.page == 0 ? "" : this.page,
        ...this.form,
      }).then((data) => {
        if (data.success) {
          // let list = []
          //  data.r.list.filter((e) => {
          //         //过滤掉.publishStatus == '1'这条数据
          //            if(e.publishStatus == '1'){
          //              console.log(e)
          //              list = list.concat(e);
          //            }
          //  })
          //  console.log(list)

          this.dataList = data.r.list;
          this.total = data.r.count;
          this.loading = false;
        }
      });
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.refreshList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageNo = val;
      this.refreshList();
    },
    changePage(page) {
      this.page = page;
      if (this.page == "0") {
        this.refreshList();
      } else {
        this.loading = true;
        this.$getHttp("/pc/homePage/getAllCopyright", {
          // userId: this.userInfo.userId,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          orderBy: this.orderBy,
          checkStatus: "4",
          proType: this.page == 0 ? "" : this.page,
          ...this.form,
        }).then((data) => {
          // this.form = data.r.list
          // console.log(this.form,"!!!!!!!!!!!")
          if (data.success) {
            this.dataList = data.r.list;
            this.total = data.r.count;
            this.loading = false;
          }
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.el-tooltip {
  text-align: center;
}
#box {
  // position: absolute;
  // left: 0;
  // top: 0;
  // // width: 100%;
  // height: 100%;
   background: #f3f6f8;
}
.box {
  background:  #0068b7;
}
.box1 {
  background: #f2f2f2;
}
.forms {
  padding-top: 30px;
  .el-form--inline .el-form-item {
    margin-right: 0px;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 45px;
    line-height: 45px;
    font-size: 20px;
    width: 190px;
  }
  /deep/ .el-form-item--small .el-form-item__label {
    line-height: 45px;
    font-size: 20px;
  }
}
.home {
  height: calc(100% - 243px);
  background-color: #f3f6f8;
  min-height: 690px;
  overflow: auto;
   width: 1200px;
  display: block;
  margin: 0 auto;
  .content {
    height: 100%;
    background-color: #fff;
  }
  .left {
    width: 300px;
    max-height: 690px;
    background-color: #dee8f8;
    overflow-x: hidden;
    overflow-y: overlay;
    .tab_title {
      color: #333333;
      height: 37px;
      font-size: 20px;
      line-height: 37px;
      color: #333333;
      opacity: 1;
      margin: 40px 0 13px 20px;
    }
    .tab_item {
      background: #dee8f8;
      height: 54px;
      line-height: 54px;
      color: #333;
       
      font-size: 18px;
      opacity: 1;
      text-indent: 70px;
      position: relative;
      transition: all 0.5s;
      cursor: pointer;
      .iconfont {
        position: absolute;
        top: 50%;
        right: 20px;
        font-size: 20px;
        transform: translateY(-50%);
      }
    }
    .tab_item:hover {
      color:  #0068b7;
      background: #fff;
      transition: all 0.5s;
    }
    .active {
      color:  #0068b7;
      background: #fff;
    }
  }
  .right {
    width: 980px;
    height: 100%;
    position: relative;
    background: #ffffff;
    padding: 0px 40px 10px 37px;
    box-sizing: border-box;
    .iframe {
      width: 100%;
      height: 100%;
    }
  }
}
.el-input__inner {
  width: 171px;
}
::-webkit-scrollbar {
	display:none
}
</style>



// WEBPACK FOOTER //
// src/view/announcement/index.vue